export const PUBLIC_ROUTES: string[] = ["/login", "/forgot"];
